<ng-template>
    <ngx-skeleton-loader *ngIf="isLoading" count="5"
                         [theme]="{ width: '200px', height: '200px' }"></ngx-skeleton-loader>
</ng-template>
<div *ngIf="!isLoading">
    <apx-chart
            id="donutAmeliorationPoint"
            [chart]="options.chart"
            [series]="options.series"
            [labels]="options.labels"
            [legend]="options.legend"
            [colors]="options.colors"
            [plotOptions]="options.plotOptions"
            [dataLabels]="options.dataLabels"
    >
    </apx-chart>
</div>
